import styled from '../../../Styles/themed-styled-components';

import { Select } from '../../../Components/Select/Select';

export const StyledSelect = styled(Select)`
  &&&& {
    width: 100%;
  }
`;
